import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityCard} from './entity-card.model';
import * as Actions from './entity-card.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityCardsFeatureKey = 'entityCards';

export interface State extends EntityState<EntityCard> {
}

export const adapter: EntityAdapter<EntityCard> = createEntityAdapter<EntityCard>();

export const initialState: State = adapter.getInitialState(initial);

const entityActions: ActionsExample<EntityCard> = {
  add: Actions.addEntityCard,
  adds: Actions.addEntityCards,
  clear: Actions.clearEntityCards,
  remove: Actions.deleteEntityCard,
  removes: Actions.deleteEntityCards,
  load: Actions.loadEntityCards,
  update: Actions.updateEntityCard,
  updates: Actions.updateEntityCards,
  upsert: Actions.upsertEntityCard,
  upserts: Actions.upsertEntityCards,
};

const entityCardReducer = entityReducer(initialState, entityActions, adapter);

export function reducer(state: State | undefined, action: Action): State {
  return entityCardReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


